import FrontText from "../FrontText";

const FrontSquareBeforeText = ({ children, className = '' }) => {
    return (
        <FrontText
            textSize="20/24-m-16/22"
            className={`text-dark-blue-standard font-bold flex items-center uppercase ${className}`}
        >
            <span className="w-[14px] h-[14px] bg-dark-blue-standard mr-1.5 shrink-0"></span>
            <span>{children}</span>
        </FrontText>
    );
};

export default FrontSquareBeforeText;
